/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_HomeInputs */

const en_portal_nav_home = /** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const ar_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const he_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const ur_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const es_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const fr_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const de_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const pt_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const hi_portal_nav_home = en_portal_nav_home;

/** @type {(inputs: Portal_Nav_HomeInputs) => LocalizedString} */
const bn_portal_nav_home = en_portal_nav_home;

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Portal_Nav_HomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_home = /** @type {((inputs?: Portal_Nav_HomeInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_HomeInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_home(inputs)
	if (locale === "he") return he_portal_nav_home(inputs)
	if (locale === "ur") return ur_portal_nav_home(inputs)
	if (locale === "es") return es_portal_nav_home(inputs)
	if (locale === "fr") return fr_portal_nav_home(inputs)
	if (locale === "de") return de_portal_nav_home(inputs)
	if (locale === "pt") return pt_portal_nav_home(inputs)
	if (locale === "hi") return hi_portal_nav_home(inputs)
	if (locale === "bn") return bn_portal_nav_home(inputs)
	return /** @type {LocalizedString} */ ("Home")
});